import React from "react";

const Divider = ({ className }) => {
  return <div className={`w-full h-[1px] bg-global-divider-soft ${className}`}></div>;
};

export default Divider;
